import { CommunicationTemplateType } from "@bbj-types/communication/enum";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import MessageIcon from "@mui/icons-material/MessageOutlined";
import { DialogContent, MenuItem, Select, Stack, Typography } from "@mui/material";
import { socialOfferVariables } from "@root/utils/templateVariables/socialOffer";
import { EmailForm, FormSms } from "@styleguide";
import { Controller } from "react-hook-form";
import { useSendSocialOfferContext } from "../logics/context";
import { typeGuardCommunicationMode } from "../logics/utils";

export const SendSocialOfferModalContent = () => {
  const control = useSendSocialOfferContext("control");
  const setValue = useSendSocialOfferContext("setValue");
  const handleModeChange = useSendSocialOfferContext("handleModeChange");
  const candidate = useSendSocialOfferContext("candidate");
  const mode = useSendSocialOfferContext("mode");
  const templates = useSendSocialOfferContext("templates");
  const setAttachmentsLoading = useSendSocialOfferContext("setAttachmentsLoading");

  return (
    <DialogContent sx={{ position: "relative", display: "flex", flexDirection: "column", gap: 2, paddingBottom: 0 }}>
      <Stack
        direction="row"
        sx={{
          gap: 2,
          alignItems: "center",
          paddingBottom: 2,
        }}
      >
        <Typography sx={{ flexBasis: "50%" }} variant="body1">
          Comment souhaitez-vous transmettre l'offre de service ?
        </Typography>
        <Select
          size="small"
          value={mode}
          onChange={(e) => {
            handleModeChange(typeGuardCommunicationMode(e.target.value));
          }}
          sx={{ minWidth: 200, flexBasis: "50%" }}
        >
          {candidate.optInEmail && (
            <MenuItem value={CommunicationTemplateType.EMAIL}>
              <Stack sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                <EmailIcon fontSize="small" color="error" />
                <Typography>Proposition par email</Typography>
              </Stack>
            </MenuItem>
          )}
          {candidate.optInPhone && (
            <MenuItem value={CommunicationTemplateType.SMS}>
              <Stack sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                <MessageIcon fontSize="small" color="error" />
                <Typography>Proposition par SMS</Typography>
              </Stack>
            </MenuItem>
          )}
        </Select>
      </Stack>
      {mode === CommunicationTemplateType.EMAIL ? (
        <Stack
          sx={{
            gap: 3,
          }}
        >
          <Typography variant="subtitle1SemiBold" color="primary">
            Contenu
          </Typography>
          <EmailForm
            control={control}
            setValue={setValue}
            templates={templates.emailTemplates}
            candidateId={candidate._id}
            emails={[
              {
                address: candidate.mail ?? "",
                name: `${candidate.firstName} ${candidate.lastName}`,
              },
            ]}
            setAttachmentsLoading={setAttachmentsLoading}
            variables={socialOfferVariables}
          />
        </Stack>
      ) : (
        <Stack>
          <Typography variant="subtitle1SemiBold" color="primary" sx={{ mb: 3 }}>
            Contenu
          </Typography>
          <Controller
            name="content"
            control={control}
            render={({ field }) => (
              <FormSms
                value={field.value}
                onChange={field.onChange}
                templates={templates.smsTemplates}
                variableList={socialOfferVariables}
                characterLimit={400}
                hardCharacterLimit
                slotProps={{
                  root: {
                    sx: {
                      width: "50%",
                    },
                  },
                }}
              />
            )}
          />
        </Stack>
      )}
    </DialogContent>
  );
};
